import { createElement, forwardRef, useMemo } from 'react';
import PropTypes from 'prop-types';

import { parseHtmlToReact } from 'helpers/HtmlHelpers';
import { withErrorBoundary } from 'components/common/MartyErrorBoundary';

// Sanitizes raw HTML strings and turns it into React nodes.
// It can also accept JSX as children if you need a fallback.
export const HtmlToReact = forwardRef(({ children, noContainer = false, containerEl = 'div', ...otherProps }, ref) => {

  const contents = useMemo(() => {
    const childrenType = typeof children;
    if (childrenType === 'object') { // Object for when JSX
      return children;
    } else if (childrenType === 'string') { // String for when raw HTML that we need to parse
      return parseHtmlToReact(children);
    } else {
      return null;
    }
  }, [children]);

  if (!contents) {
    return null;
  } else if (noContainer) {
    return contents;
  } else {
    return createElement(containerEl, { ...otherProps, ref }, contents);
  }
});

HtmlToReact.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  noContainer: PropTypes.bool,
  containerEl: PropTypes.string
};

const HtmlToReactWithErrorBoundary = withErrorBoundary('HtmlToReact', HtmlToReact);

export default HtmlToReactWithErrorBoundary;
